import axios from 'axios';

export const getIspuLocatorIframe = async (tabName: string, entityId: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`/api/ispu-locator/${tabName}/${entityId}`, {
        responseType: 'text',
        headers: { Accept: 'text/html' },
        transformResponse: [data => data], // spriječi parsiranje JSON-a
      })
      .then(result => resolve(result.data))
      .catch(error => {
        if (axios.isAxiosError(error)) {
          const raw = error.response?.data;

          let problem = raw;
          if (typeof raw === 'string') {
            try {
              problem = JSON.parse(raw);
            } catch {}
          }

          reject(problem);
        }
        reject(error);
      });
  });
};
